import { render, staticRenderFns } from "./MakeCutScrap.vue?vue&type=template&id=155822c3"
import script from "./MakeCutScrap.vue?vue&type=script&lang=js"
export * from "./MakeCutScrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports